import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { NewsletterForm } from "@/components/NewsletterForm";

const STORAGE_KEY = "newsletter_popup_seen_v1";

export const NewsletterPopup = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (localStorage.getItem(STORAGE_KEY)) return;

    const onScroll = () => {
      if (window.scrollY > 200) {
        setOpen(true);
        localStorage.setItem(STORAGE_KEY, "1");
        window.removeEventListener("scroll", onScroll);
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-foreground/70 backdrop-blur-sm animate-[page-fade_0.3s_ease-out]"
      role="dialog"
      aria-modal="true"
      onClick={() => setOpen(false)}
    >
      <div
        className="relative bg-foreground text-background w-full max-w-md p-8 sm:p-10 shadow-2xl animate-[page-fade_0.4s_ease-out]"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          aria-label="Close"
          onClick={() => setOpen(false)}
          className="group absolute top-3 right-3 p-1.5 transition-colors hover:bg-red-600"
        >
          <X className="w-5 h-5 text-background transition-colors group-hover:text-background" />
        </button>
        <p className="font-display text-accent text-xs tracking-widest mb-3 text-center">JOIN THE MOB</p>
        <h2 className="font-display text-3xl sm:text-4xl text-center leading-none mb-3">
          GET 15% OFF<br />YOUR FIRST ORDER
        </h2>
        <p className="text-background/70 text-sm text-center mb-6">
          Subscribe for early drops, restock alerts and members-only releases.
        </p>
        <NewsletterForm source="popup" />
      </div>
    </div>
  );
};